import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ResponseModel } from '../models/api.model';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';


@Injectable()
export class InvoiceService extends BaseService {

  constructor(private http: HttpClient, private router: Router, messageService: MessageService) {
    super(messageService);

  }

  edit(form: any) {
    return this.http.put(`${environment.baseUrl}api/order/editaccounting`, form)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  send(form: any) {
    return this.http.post(`${environment.baseUrl}api/invoice/send`, form)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  getAccountingBulkEdit(invoiceIds: any) {
    let p = new HttpParams({ fromObject: { invoiceIds } });
    return this.http.get(`${environment.baseUrl}api/detail/BulkInvoice`, { params: p })
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  saveAccountingBulkEdit(form: any) {
    return this.http.post(`${environment.baseUrl}api/order/BulkInvoiceEdit`, form)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }
}
